
<div class="simple-hostings">
  <div class="hosting-section">
    <label class="hosting-label">Alojamiento a trabajar hoy</label>
    
    <div class="dropdown">
       <button class="dropdown-btn" (click)="toggleDropdown()">
        {{ selectedHosting ? getHostingDisplayText(selectedHosting) : (hostings.length > 0 ? getHostingDisplayText(hostings[0]) : 'No hay alojamientos') }}
        <span class="arrow" [class.rotated]="isDropdownOpen">▼</span>
      </button>
      
      <div class="dropdown-content" *ngIf="isDropdownOpen">
        <div *ngIf="loading" class="loading-item">Loading...</div>
        
        <div *ngIf="!loading && hostings.length > 0">
          <div 
            *ngFor="let hosting of hostings; let i = index" 
            class="dropdown-item"
            [class.selected]="selectedHosting?.id === hosting.id"
            (click)="onHostingSelect(hosting)">
            {{ i + 1 }}. {{ hosting.name }} - {{ hosting.location.city}} - ${{ hosting.type }}
          </div>
        </div>
        
        <div *ngIf="!loading && hostings.length === 0" class="no-items">
          No hay alojamientos disponibles
        </div>
      </div>
    </div>
  </div>
</div>